var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning44 = function SvgWarning44(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 25.6a1.8 1.8 0 0 1-1.8-1.8V13a1.8 1.8 0 0 1 3.6 0v10.8a1.8 1.8 0 0 1-1.8 1.8ZM22 29.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 22c0-9.941 8.059-18 18-18s18 8.059 18 18-8.059 18-18 18S4 31.941 4 22ZM22 7.6C14.047 7.6 7.6 14.047 7.6 22S14.047 36.4 22 36.4 36.4 29.953 36.4 22 29.953 7.6 22 7.6Z",
    fill: "currentColor"
  })));
};
export default SvgWarning44;